import Decimal from "decimal.js";
export var numericStringRegex = /^(?:[1-9]\d*|0)\.?\d*$/;
export var isNumericString = function(str) {
    var _str_toString;
    return numericStringRegex.test((_str_toString = str === null || str === void 0 ? void 0 : str.toString()) !== null && _str_toString !== void 0 ? _str_toString : '');
};
export var stripSpecialNumericChars = function(value) {
    var _value_toString_replace;
    return isNumericValue(value) || isNumericString(value === null || value === void 0 ? void 0 : value.toString().replace(/(\$|,|%)/g, '')) ? value === null || value === void 0 ? void 0 : (_value_toString_replace = value.toString().replace(/(\$|,|%)/g, '')) === null || _value_toString_replace === void 0 ? void 0 : _value_toString_replace.trim() : '';
};
export var isNumericValue = function(value) {
    return typeof value === 'number' || isNumericString(value);
};
export var parseNumber = function(value) {
    return isNaN(Number(stripSpecialNumericChars(value))) ? '' : stripSpecialNumericChars(value) ? new Decimal(stripSpecialNumericChars(value)).toNumber() : '';
};

//# sourceMappingURL=parseNumber.js.map